module.exports = __webpack_public_path__ + "img/noData.8076da29.png";